import store from '~/store'

const authorizedRoles = {
  'administrator': [1, 2, 3, 4],
  'manager': [2, 3, 4, 5],
  'student': [3],
  'professional': [4, 5],
  'recipient': []
};

export default async (to, from, next) => {
  const user = store.getters['auth/user'];
  const redirection = {
    name: 'settings.profile',
    params: { id: user.role_id }
  };

  // Redirect recipients to their profile.
  if (user.role_id == 5) {
    return next(redirection);
  }

  const id = to.params.id;

  // Let the user update its own profile.
  if (user.id == id) {
    return next();
  }

  const roles = store.getters['roles/roles'];
  const profile = store.getters['users/users'].find(user => user.id == id);

  if (!profile) {
    return next(redirection);
  }

  const isAuthorized = authorizedRoles[user.role.title].includes(profile.role_id);

  if (isAuthorized) {
    next()
  } else {
    return next(redirection);
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/user-update.js